import { Helmet } from "react-helmet-async";

// Canonical resolution rules for indexation hygiene:
//   1. If a `canonical` prop is passed, use it verbatim (page opts in).
//   2. Otherwise, derive a self-canonical from window.location using the
//      production origin, current pathname, and a curated allowlist of
//      indexable query params. `?tag=` (hub filter) is intentionally
//      stripped so /glp-guide?tag=X collapses to /glp-guide.
const PROD_ORIGIN = "https://metaboliclabos.com";
const INDEXABLE_QUERY_PARAMS = new Set([]); // add any params that must stay in the canonical

function deriveCanonical() {
  if (typeof window === "undefined") return null;
  try {
    const path = window.location.pathname || "/";
    const search = window.location.search || "";
    if (!search) return `${PROD_ORIGIN}${path}`;
    const params = new URLSearchParams(search);
    const kept = new URLSearchParams();
    for (const [k, v] of params.entries()) {
      if (INDEXABLE_QUERY_PARAMS.has(k)) kept.append(k, v);
    }
    const qs = kept.toString();
    return `${PROD_ORIGIN}${path}${qs ? `?${qs}` : ""}`;
  } catch {
    return null;
  }
}

const SEO = ({ title, description, canonical, noIndex }) => {
  const resolvedCanonical = canonical || deriveCanonical();
  return (
    <Helmet>
      <title>{title ? `${title} | MetabolicLabOS` : "MetabolicLabOS — GLP-1 Educational Resources"}</title>
      <meta name="description" content={description || "Practical protocols for managing GLP-1 medication side effects. Educational guides trusted by Ozempic, Wegovy, and Mounjaro users."} />
      {resolvedCanonical && <link rel="canonical" href={resolvedCanonical} />}
      {noIndex && <meta name="robots" content="noindex, nofollow" />}
      {/* Open Graph — helps Google understand the primary URL when duplicates exist */}
      {resolvedCanonical && <meta property="og:url" content={resolvedCanonical} />}
      {title && <meta property="og:title" content={title} />}
      {description && <meta property="og:description" content={description} />}
      <meta property="og:type" content="article" />
      <meta property="og:site_name" content="MetabolicLabOS" />
    </Helmet>
  );
};

export default SEO;
